import { getRequest, postRequest, putRequest } from "api/axiosClient";
import { ConvertDraftResponseType, GetDraftResponseType, UpdateDraftResponseType } from "api/response";
// import { GetAttachmentsResponseType } from "api/response";

const { REACT_APP_CARGOBASE_BASE_URL } = import.meta.env;
const baseURL = `${REACT_APP_CARGOBASE_BASE_URL}/order`;

const getConsolidatedOrders = (config = {}) => getRequest(`${baseURL}/listing`, config);
const postConsolidatedOrders = (payload = {}) => postRequest(`${baseURL}s/start-consolidation`, payload);
const startEditConsolidatedRequest = (id: string) => postRequest(`${baseURL}s/start-edit-consolidation/${id}`, {});

const convertOrderDraft = (id: string) => {
  const url = `${baseURL}/draft/${id}/submit`;
  return postRequest<ConvertDraftResponseType>(url, {});
};

const getOrderDraft = (id: string) => {
  const url = `${baseURL}/draft/${id}`;
  return getRequest<GetDraftResponseType>(url);
};

const updateOrderDraft = (payload: UpdateDraftResponseType, id: string, config = {}) => {
  const url = `${baseURL}/draft/${id}`;
  return putRequest<UpdateDraftResponseType>(url, payload, config);
};

// eslint-disable-next-line import/prefer-default-export
export {
  getConsolidatedOrders,
  postConsolidatedOrders,
  startEditConsolidatedRequest,
  convertOrderDraft,
  getOrderDraft,
  updateOrderDraft,
};
